module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/thZRqk/tc-custom/9780795352713.jpg?1705212305267",
      "alt": "This image is the cover for the book Vicar's Daughter, The Cullen Collection"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Vicar's Daughter, The Cullen Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The fictional memoirs of Victorian-era housewife. Third in the Marshmallows Trilogy following "), _c('i', [_vm._v("Annals of a Quiet Neighbourhood")]), _vm._v(" and "), _c('i', [_vm._v("The Seaboard Parish")]), _vm._v(".")])]), _c('i', [_vm._v("The Vicar’s Daughter")]), _vm._v(", the 1872 sequel to "), _c('i', [_vm._v("The Seaboard Parish")]), _vm._v(", follows the early married life of one of Harry Walton’s (fictional narrator of "), _c('i', [_vm._v("Annals of a Quiet Neighbourhood")]), _vm._v(") daughters. This third book in the Marshmallows Trilogy is representative of the rising interest women were taking in Victorian society. Written in the first person in the fictional guise of female authorship, its characterization of MacDonald’s friend and patron Lady Noel Byron is one of the noteworthy elements of the book.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      George MacDonald, Michael Phillips\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0